// extracted by mini-css-extract-plugin
var _1 = "OrderPageStyle-module__company-about___GS3he";
var _2 = "OrderPageStyle-module__company-avatar___LhByB";
var _3 = "OrderPageStyle-module__company-details___SKadq";
var _4 = "OrderPageStyle-module__company-link___JR6z2";
var _5 = "OrderPageStyle-module__company-name___hcVib";
var _6 = "OrderPageStyle-module__company-spv-container___Ylrwj";
var _7 = "OrderPageStyle-module__company-spv-main___T6lfl";
var _8 = "OrderPageStyle-module__company-spv-name___EfKUe";
var _9 = "OrderPageStyle-module__company-about___GS3he";
var _a = "OrderPageStyle-module__company-avatar___LhByB";
var _b = "OrderPageStyle-module__company-details___SKadq";
var _c = "OrderPageStyle-module__company-link___JR6z2";
var _d = "OrderPageStyle-module__company-name___hcVib";
var _e = "OrderPageStyle-module__company-spv-container___Ylrwj";
var _f = "OrderPageStyle-module__company-spv-main___T6lfl";
var _10 = "OrderPageStyle-module__company-spv-name___EfKUe";
var _11 = "OrderPageStyle-module__cta___Abfx1";
var _12 = "OrderPageStyle-module__cta-disabled___RoGcQ";
var _13 = "OrderPageStyle-module__cta-no-buy-orders___eGgTv";
var _14 = "OrderPageStyle-module__cta-sell___ndngu";
var _15 = "OrderPageStyle-module__cta-disabled___RoGcQ";
var _16 = "OrderPageStyle-module__cta-no-buy-orders___eGgTv";
var _17 = "OrderPageStyle-module__cta-sell___ndngu";
var _18 = "OrderPageStyle-module__fade-in-up___GMNUX";
var _19 = "OrderPageStyle-module__fadeInLeftShortAnimation___hUFSB";
var _1a = "OrderPageStyle-module__fadeInLeftShortestAnimation___e6IKd";
var _1b = "OrderPageStyle-module__fadeInRightShortAnimation___bMnaR";
var _1c = "OrderPageStyle-module__fade-in-up___GMNUX";
var _1d = "OrderPageStyle-module__fadeInUpAnimation___Ah2dm";
var _1e = "OrderPageStyle-module__handle-animation___acsra";
var _1f = "OrderPageStyle-module__handle-animation___acsra";
var _20 = "OrderPageStyle-module__header-content___DsXdw";
var _21 = "OrderPageStyle-module__header-content-no-buy-orders____TTTt";
var _22 = "OrderPageStyle-module__header-content___DsXdw";
var _23 = "OrderPageStyle-module__header-content-no-buy-orders____TTTt";
var _24 = "OrderPageStyle-module__max-width-800___xNmGS";
var _25 = "OrderPageStyle-module__max-width-800___xNmGS";
var _26 = "OrderPageStyle-module__orders___OKKxq";
var _27 = "OrderPageStyle-module__scroll-to-trades___qt4sv";
var _28 = "OrderPageStyle-module__scroll-to-trades___qt4sv";
var _29 = "OrderPageStyle-module__shares-container___MK4Tk";
var _2a = "OrderPageStyle-module__shares-container___MK4Tk";
var _2b = "OrderPageStyle-module__toggle-company-desc___prMVe";
var _2c = "OrderPageStyle-module__toggle-company-desc___prMVe";
var _2d = "OrderPageStyle-module__transaction-history___kaAuU";
var _2e = "OrderPageStyle-module__transaction-history___kaAuU";
export { _1 as "company-about", _2 as "company-avatar", _3 as "company-details", _4 as "company-link", _5 as "company-name", _6 as "company-spv-container", _7 as "company-spv-main", _8 as "company-spv-name", _9 as "companyAbout", _a as "companyAvatar", _b as "companyDetails", _c as "companyLink", _d as "companyName", _e as "companySpvContainer", _f as "companySpvMain", _10 as "companySpvName", _11 as "cta", _12 as "cta-disabled", _13 as "cta-no-buy-orders", _14 as "cta-sell", _15 as "ctaDisabled", _16 as "ctaNoBuyOrders", _17 as "ctaSell", _18 as "fade-in-up", _19 as "fadeInLeftShortAnimation", _1a as "fadeInLeftShortestAnimation", _1b as "fadeInRightShortAnimation", _1c as "fadeInUp", _1d as "fadeInUpAnimation", _1e as "handle-animation", _1f as "handleAnimation", _20 as "header-content", _21 as "header-content-no-buy-orders", _22 as "headerContent", _23 as "headerContentNoBuyOrders", _24 as "max-width-800", _25 as "maxWidth800", _26 as "orders", _27 as "scroll-to-trades", _28 as "scrollToTrades", _29 as "shares-container", _2a as "sharesContainer", _2b as "toggle-company-desc", _2c as "toggleCompanyDesc", _2d as "transaction-history", _2e as "transactionHistory" }
